module.exports = function(ejs) {
var __t, __p = '';
__p += '<div class="ggs-gallery-preview__header" ' +
((__t = ( ejs.LE
    ? `roe-if-emitter=":: $ctrl.ggsProperties.key2emitter.show_user_info_in_preview"
       roe-if="  $ctrl.ggsProperties.show_user_info_in_preview"`
    : `ng-if=":: $ctrl.ggsProperties.show_user_info_in_preview"`
  )) == null ? '' : __t) +
' ><ggs-gallery-user class="ggs-gallery-preview__user ggs-gallery-preview__user_text" ggs-post=":: $ctrl.ggsPost" ggs-properties=":: $ctrl.ggsProperties"></ggs-gallery-user><div class="ggs-gallery-preview__hr"></div></div><div class="ggs-gallery-preview__showcase" ng-click=":: $ctrl.selectPostHandler()"><ggs-gallery-text-preview ggs-post=":: $ctrl.ggsPost" ggs-properties=":: $ctrl.ggsProperties" ggs-content-done-callback=":: $ctrl.contentDoneCallback" ggs-content-fail-callback=":: $ctrl.contentFailCallback"></ggs-gallery-text-preview><img class="ggs-gallery-preview__marker ggs-gallery-preview__marker_unknown" ng-if=":: $ctrl.ggsPost.info.isUnknown" src="' +
((__t = ( ejs.UNKNOWN_ICON )) == null ? '' : __t) +
'"></div><div class="ggs-gallery-preview__footer" ' +
((__t = ( ejs.LE
    ? `roe-if-emitter=":: $ctrl.ggsProperties.key2emitter.show_source_in_preview"
       roe-if="  $ctrl.ggsProperties.show_source_in_preview"`
    : `ng-if=":: $ctrl.ggsProperties.show_source_in_preview"`
  )) == null ? '' : __t) +
' ><div class="ggs-gallery-preview__hr"></div><ggs-icon class="ggs-gallery-preview__letter-icon" ggs-icon-name=":: $ctrl.ggsPost.info.host"></ggs-icon></div>';
return __p
}